import { useNavigate } from "react-router-dom";
import {
    Box,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import StarIcon from "@mui/icons-material/Star";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VerifiedIcon from "@mui/icons-material/Verified";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const VendorRatings = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const rows = [
        {
            id: "VR001",
            name: "Elite Property Management",
            email: "contact@eliteproperty.ae",
            phone: "+971 4 555 7890",
            verified: true,
            date: "14/12/2025",
            orderId: "ORD-VND-2301",
            serviceId: "SRV-AC-102",
            serviceName: "Commercial AC Maintenance",
            rating: 5,
            title: "Outstanding professional service",
            review:
                "The technicians were punctual, well-trained, and completed the AC maintenance without disruption. Highly reliable service partner.",
            status: "approved",
        },
        {
            id: "VR002",
            name: "GreenLeaf Cafés LLC",
            email: "ops@greenleafcafes.ae",
            phone: "+971 50 778 4412",
            verified: true,
            date: "13/12/2025",
            orderId: "ORD-VND-2294",
            serviceId: "SRV-CLN-310",
            serviceName: "Commercial Kitchen Deep Cleaning",
            rating: 4,
            title: "Clean and compliant service",
            review:
                "Kitchen was cleaned thoroughly and met hygiene standards. Minor delay in arrival, but quality was good.",
            status: "approved",
        },
        {
            id: "VR003",
            name: "Nova Tech Solutions",
            email: "admin@novatech.ae",
            phone: "+971 52 901 6623",
            verified: false,
            date: "11/12/2025",
            orderId: "ORD-VND-2279",
            serviceId: "SRV-IT-455",
            serviceName: "Network Setup & Configuration",
            rating: 3,
            title: "Average experience",
            review:
                "Network setup was completed, but documentation and post-installation support could be improved.",
            status: "pending",
        },
        {
            id: "VR004",
            name: "Skyline Real Estate",
            email: "maintenance@skyline-re.com",
            phone: "+971 4 662 1189",
            verified: true,
            date: "09/12/2025",
            orderId: "ORD-VND-2251",
            serviceId: "SRV-SEC-118",
            serviceName: "24/7 Security Staffing",
            rating: 2,
            title: "Below expectations",
            review:
                "Security staff lacked alertness and professionalism during night shifts. Needs better training.",
            status: "approved",
        },
        {
            id: "VR005",
            name: "UrbanFit Gym",
            email: "support@urbanfitgym.ae",
            phone: "+971 55 309 8801",
            verified: true,
            date: "08/12/2025",
            orderId: "ORD-VND-2238",
            serviceId: "SRV-ELC-287",
            serviceName: "Electrical Safety Inspection",
            rating: 5,
            title: "Highly skilled technicians",
            review:
                "Inspection was detailed and professional. All issues were clearly explained with actionable recommendations.",
            status: "approved",
        },
    ];

    const ratingDistribution = [
        { stars: 5, count: 16 },
        { stars: 4, count: 21 },
        { stars: 3, count: 10 },
        { stars: 2, count: 3 },
        { stars: 1, count: 0 },
    ];

    const maxCount = Math.max(...ratingDistribution.map(r => r.count));

    return (
        <>
            <div className="main_title">
                <h1>Manage Vendor Ratings & Reviews</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -Vendor Ratings & Reviews
                </p>
            </div>
            <div className="stats_boxes gap_m">
                {/* TOTAL REVIEWS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            50
                            <p>Total Reviews</p>
                        </h2>
                        <figure className="warning">
                            <StarIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* AVERAGE RATING */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4.0
                            <p>Average Rating</p>
                        </h2>
                        <figure className="sucess">
                            <TrendingUpIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* VERIFIED PURCHASES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            32
                            <p>Verified Purchases</p>
                        </h2>
                        <figure className="blue">
                            <VerifiedIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* PENDING REVIEWS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            4
                            <p>Pending Review</p>
                        </h2>
                        <figure className="danger">
                            <ErrorOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>
            <div className="cards rating_distribution mt_20">
                <h4 className="card_title">Rating Distribution</h4>

                <div className="rating_dist_list">
                    {ratingDistribution.map((item) => (
                        <div className="rating_row" key={item.stars}>
                            {/* Stars */}
                            <div className="stars">
                                {item.stars} <span>★</span>
                            </div>

                            {/* Progress bar */}
                            <div className="bar">
                                <span
                                    className="fill"
                                    style={{
                                        width: `${(item.count / maxCount) * 100}%`,
                                    }}
                                />
                            </div>

                            {/* Count */}
                            <div className="count">{item.count}</div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="reviews_wrapper mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search product..."
                            />
                        </Box>
                        <div className="form">
                            <select>
                                <option value="all">All Ratings</option>
                                <option value="footwear">5 Star</option>
                                <option value="clothing">4 Star</option>
                                <option value="accessories">3 Star</option>
                                <option value="accessories">2 Star</option>
                                <option value="accessories">1 Star</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="reviews_list">

                    {rows.map((row) => (
                        <div className="review_card" key={row.id} onClick={() => navigate("/manage-vendors/view-vendor/view-service")}>
                            {/* LEFT – User */}
                            <div className="review_user">
                                <figure className="avatar">
                                    {row.name.charAt(0)}
                                </figure>

                                <div className="user_info">
                                    <h4>
                                        {row.name}
                                        {row.verified && (
                                            <span className="verified_badge">✔ Verified</span>
                                        )}
                                    </h4>
                                    <p>{row.email}</p>
                                    <small>{row.date}</small>
                                </div>
                            </div>

                            {/* CENTER – Review + Product */}
                            <div className="review_content">
                                {/* Product Info */}
                                <div className="product_info">
                                    <span className="pid">#{row.serviceId}</span>
                                    <span className="pname">{row.serviceName}</span>
                                </div>

                                {/* Rating */}
                                <div className="rating">
                                    {"⭐".repeat(row.rating)}
                                    {row.rating < 5 && "☆".repeat(5 - row.rating)}
                                </div>

                                <h5>{row.title}</h5>
                                <p>{row.review}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </>
    );
};

export default VendorRatings;
